import { getAppointDate, AppointType } from '../service'
import dayjs from 'dayjs'
const KEYS = {
  APPOINT: '预订须知',
  USE: '使用说明',
  OTHER: '其他说明'
}

const refund = { 0: '不可退', 1: '随时退', 2: '条件退' }

export const getNoticeData = (noticeInfo, skuInfo) => {
  const noticeData = {}
  // 预订说明-----------
  let str = ''
  if (noticeInfo.firstBookingDate) {
    const day = dayjs(+noticeInfo.firstBookingDate)
    console.log(day)

    const tomorrow = dayjs().add(1, 'd')
    if (day.isSame(new Date(), 'day')) {
      str = '可订今日'
    } else if (day.isSame(tomorrow, 'day')) {
      str = '可订明日'
    } else if (day.isAfter(new Date())) {
      str = `可订${day.format('M月D日')}`
    }
  }

  noticeData[KEYS.APPOINT] = {}
  if (str) {
    noticeData[KEYS.APPOINT]['预订时间'] = {
      tag: str,
      type: 1
    }
  }

  noticeData[KEYS.APPOINT]['有效期'] = {
    info: skuInfo.termOfValidity
  }

  const afterActiveTime = parseInt(noticeInfo.afterActiveTime || '1')
  if (afterActiveTime !== 0 && afterActiveTime !== -1) {
    noticeData[KEYS.APPOINT]['生效时间'] = {
      info: noticeInfo.afterOrderMsg || `预订${afterActiveTime}分钟后可用`
    }
  }

  if (noticeInfo.ticketSpeed) {
    noticeData[KEYS.APPOINT]['出票速度'] = {
      info: noticeInfo.ticketSpeed
    }
  }

  if (noticeInfo.quickEnter) {
    noticeData[KEYS.APPOINT]['无需取票'] = {
      info: noticeInfo.useMethod
    }
  } else {
    noticeData[KEYS.APPOINT]['需取票'] = {
      info: noticeInfo.useMethod
    }
  }

  const refundStr = refund[noticeInfo.isAnyTimeRefund ?? '0']
  noticeData[KEYS.APPOINT][refundStr] = {
    info: noticeInfo.retreatRule
  }

  noticeData[KEYS.APPOINT]['适用条件'] = {
    info: noticeInfo.applicability
  }

  //使用说明
  noticeData[KEYS.USE] = {}
  if (noticeInfo.entryTimeAddress) {
    noticeData[KEYS.USE]['入园地址/时间'] = {
      info: noticeInfo.entryTimeAddress
    }
  }
  if (noticeInfo.getTicketAddressTime) {
    noticeData[KEYS.USE]['取票地址/时间'] = {
      info: noticeInfo.getTicketAddressTime
    }
  }
  if (noticeInfo.addContain) {
    noticeData[KEYS.USE]['补充说明'] = {
      info: noticeInfo.addContain
    }
  }

  //其他说明-----------
  noticeData[KEYS.OTHER] = {}
  if (noticeInfo.priceInclude) {
    noticeData[KEYS.OTHER]['费用包含'] = {
      info: noticeInfo.priceInclude
    }
  }
  if (noticeInfo.priceNotInclude) {
    noticeData[KEYS.OTHER]['费用不含'] = {
      info: noticeInfo.priceNotInclude
    }
  }

  if (noticeInfo.limitDesc) {
    noticeData[KEYS.OTHER]['限购政策'] = {
      info: noticeInfo.limitDesc
    }
  }

  if (noticeInfo.otherIntroduce) {
    noticeData[KEYS.OTHER]['其他须知'] = {
      info: noticeInfo.otherIntroduce
    }
  }

  Object.keys(noticeData).forEach(item => {
    const value = noticeData[item]
    if (Object.keys(value).length === 0) {
      delete noticeData[item]
    }
  })

  return {
    noticeData
  }
}
